"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _licenseTc = require("@/api/master/licenseTc");
var _utils = require("@/utils");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.total = 0;
    this.listLoading = true;
    this.listQuery = {
      page: 1,
      limit: 10,
      name: undefined,
      sort: 'id,ASC',
      filter: {
        name: '$contL'
      }
    };
  }
  created() {
    this.getList();
  }
  async getList() {
    this.listLoading = true;
    try {
      const data = await (0, _licenseTc.getLicenseTcs)((0, _utils.getQuery)(this.listQuery));
      this.list = data.data;
      this.total = data.total;
    } catch (error) {
      console.error('Failed to fetch License TCs', error);
    } finally {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LicenseTcList',
  components: {
    Pagination: _index.default
  }
})], default_1);
var _default = exports.default = default_1;